import { render, staticRenderFns } from "./Topbar.vue?vue&type=template&id=12c427d1&scoped=true&"
import script from "./Topbar.vue?vue&type=script&lang=ts&"
export * from "./Topbar.vue?vue&type=script&lang=ts&"
import style0 from "./Topbar.vue?vue&type=style&index=0&id=12c427d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c427d1",
  null
  
)

export default component.exports